<span
  class="mdi mdi-map-marker-outline"
  [ngClass]="{ 'text-primary': location }"
  style="font-size: 17px"
  [ngbTooltip]="location || 'Localização não informada'"
  placement="top"
  triggers="hover"
></span>
<span
  class="selfie-icon"
  [ngClass]="{ 'text-primary': self, 'selfie-icon-gray': !self }"
  [class.cursor-pointer]="self"
  (click)="openSelfieModal()"
  [ngbTooltip]="self ? 'Ver foto do colaborador' : 'Foto não disponível'"
  placement="top"
  triggers="hover"
  style="margin-left: 4px; display: inline-flex; align-items: center;"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 20 18" fill="none" style="display: block;">
    <path d="M10 14.5C11.25 14.5 12.3125 14.0625 13.1875 13.1875C14.0625 12.3125 14.5 11.25 14.5 10C14.5 8.75 14.0625 7.6875 13.1875 6.8125C12.3125 5.9375 11.25 5.5 10 5.5C8.75 5.5 7.6875 5.9375 6.8125 6.8125C5.9375 7.6875 5.5 8.75 5.5 10C5.5 11.25 5.9375 12.3125 6.8125 13.1875C7.6875 14.0625 8.75 14.5 10 14.5ZM10 12.5C9.3 12.5 8.70833 12.2583 8.225 11.775C7.74167 11.2917 7.5 10.7 7.5 10C7.5 9.3 7.74167 8.70833 8.225 8.225C8.70833 7.74167 9.3 7.5 10 7.5C10.7 7.5 11.2917 7.74167 11.775 8.225C12.2583 8.70833 12.5 9.3 12.5 10C12.5 10.7 12.2583 11.2917 11.775 11.775C11.2917 12.2583 10.7 12.5 10 12.5ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H5.15L7 0H13L14.85 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H2ZM2 16H18V4H13.95L12.125 2H7.875L6.05 4H2V16Z" fill="currentColor"/>
  </svg>
</span>
{{ time | date : "HH:mm" }} <br />
